import { memo } from 'react';

import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverContentProps,
  PopoverProps,
  PopoverTrigger,
  PopoverTriggerProps,
} from '../Popover';
import { cn } from '../../lib/styles';

interface MenuProps extends PopoverProps {
  children: React.ReactNode;
}

export const MenuTrigger = (props: PopoverTriggerProps) => {
  return <PopoverTrigger {...props} />;
};

export const MenuClose = ({ children }: { children: React.ReactNode }) => {
  return <PopoverClose asChild>{children}</PopoverClose>;
};

export const MenuContent = ({ className, ...rest }: PopoverContentProps) => {
  return <PopoverContent className={cn('p-1.5 z-[301]', className)} {...rest} />;
};

const MenuBase = (props: MenuProps) => {
  return <Popover {...props} />;
};

export const Menu = memo(MenuBase);
